import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Container, Button, Col, Row } from 'react-bootstrap';
import Slider from "react-slick";
import CountUp from 'react-countup';
import VisibilitySensor from "react-visibility-sensor";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import AnchorLink from 'react-anchor-link-smooth-scroll';

function BabyJewels() {
    window.scrollTo(0, 0);
    const [focus, setFocus] = React.useState(false);
    return (
        <div>
            <Helmet>

                <title>369% Jump in Ecom revenue in a year and Reversed the Declining Trend in Store Footfalls</title>
                <meta name="description" content="" />
                <link rel="canonical" href="https://anbluxury.com/case-studies/baby-jewels-case-study.html" />

            </Helmet>
            {/* first fold */}
            <div className="casestudy">
                <div className="box padmmdt padmmdb">

                    <Container>

                        <p className="text-left p1 pdl10">BABY <span class="spcase">JEWELS </span> </p>
                    </Container>

                    <Container fluid className="padbsmt padbsmb">
                        <Row>
                            <Col lg="2"></Col>
                            <Col lg="8">
                                <div className="circleboxfirst circleboxfirst-relative  padssmb">
                                    <img src={`${process.env.PUBLIC_URL}/img/bgbox.png`} className="roundbx" width="30%" alt="" />

                                    <div className="boxcentered tpfold">
                                        <h4 className="d-none d-sm-block cuspn"> <span class=""> 369% Jump in Ecom revenue in a year and Reversed the Declining Trend in Store Footfalls </span><br />  and Reversed the Declining Trend in Store Footfalls  <br /></h4>
                                        <h4 className="d-block d-sm-none"> <span class="cuspn"> 369% Jump in Ecom revenue in a year  </span>  <br />  and Reversed the Declining Trend in Store Footfalls  <br /></h4>

                                    </div>
                                </div>
                            </Col>
                            <Col lg="2"></Col>
                        </Row>
                    </Container>
                </div>
            </div>
            {/* The brand fold */}
            <div className="lgbox  problem">

                <Container fluid className="tpfold pdr0 mbpdr15">
                    <Row>
                        <Col lg="4" md="4" sm="12" xs="12" className="padmmdt mbpt0 casebox offset-lg-1 ">
                            <p className="text-left p1 mrg30 " > <span class="spcase">THE</span> <strong>BRAND</strong>  </p>
                            <p className="marbmdt mbt20 ">
                                Baby Jewels, an extension of popular KSA brand Baby Fitaihi in UAE promises luxury jewelry for newborns, toddlers and teens. They're known for their playful, cute and modern designs and are pioneers in the field of children's jewelry. Currently Baby Jewels has 2 stores in UAE- Dubai Mall and Yas Mall
                            </p>
                            <br></br>
                            <br></br>
                        </Col>
                        <Col lg={{ span: 5 }} md={{ span: 4 }} sm={{ span: 12 }} xs={{ span: 12 }} className="offset-lg-1 mbpdr15">
                            <br></br>
                            <br></br>
                            <br></br>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/baby-jewels/brand.png`} width="100%" height="100%" className="img-fluid text-right" />
                            <br></br>
                            <br></br>
                            <br></br>
                        </Col>
                    </Row>
                </Container>
            </div>
            {/* The opportunity */}


            <div id="letsdo" className="seoapproach bgbl padmmdt padmmdb ">
                <Container>
                    <div className="appbox padssmb d-none d-sm-block">
                        <img src={`${process.env.PUBLIC_URL}/img/approach2.png`} className="imgwidt img-fluid" alt="" />
                        <div className="top-left">
                            <h4><strong> Conversion </strong><br /> <i> Rate </i></h4>
                            <p>High traffic, poor conversion rate</p>
                        </div>

                        <div className="top-right">
                            <h4><strong>Store  </strong><br /> <i>Footfalls</i></h4>
                            <p>Store Footfalls were too susceptible to seasonal variations.</p>
                        </div>

                        <div className="bottom-left">
                            <h4><strong>Legacy Brand</strong><br /> <i>Domination</i></h4>
                            <p>Breaking into a market dominated by legacy brands</p>
                        </div>


                        <div className="bottom-right">
                            <h4><strong>Balancing</strong><br /> <i>Parental</i></h4>
                            <p>Balancing parental preferences with child-friendly designs.</p>
                        </div>
                        <div className="centered"><h1>The <span>Challenge</span></h1></div>
                    </div>




                    <div className="appbox  padssmb d-block d-sm-none">
                        <h1>The <span>Challenge</span></h1> <br />

                        <h4><strong> Conversion </strong><br /> <i>Rate </i></h4>
                        <p>High traffic, poor conversion rate</p>
                        <img src={`${process.env.PUBLIC_URL}/img/straightline.png`} className="img-fluid" />
                        <h4><strong>Store  </strong><br /> <i>Footfalls</i></h4>
                        <p>Store Footfalls were too susceptible to seasonal variations.</p>
                        <img src={`${process.env.PUBLIC_URL}/img/straightline.png`} className="img-fluid" />
                        <h4><strong>Legacy Brand</strong><br /> <i>Domination</i></h4>
                        <p>Breaking into a market dominated by legacy brands</p>
                        <img src={`${process.env.PUBLIC_URL}/img/straightline.png`} className="img-fluid" />
                        <h4><strong>Balancing</strong><br /> <i>Parental</i></h4>
                        <p>Balancing parental preferences with child-friendly designs.</p>
                    </div>

                    <Row>
                        <Col md={2} lg={2}></Col>
                        <Col md={8} lg={8}>
                            <br></br>
                            <br></br>
                            <p>There was no Brand Identity built. Moreover, people in UAE were not aware how popular Baby Fitaihi was in KSA.</p>
                            <p>Due to no brand awareness, there was no trust in the brand</p>
                        </Col>
                        <Col md={2} lg={2}></Col>
                    </Row>






                </Container>
                {/* <img src={`${process.env.PUBLIC_URL}/img/approach.png`} className="img-fluid" /> */}
            </div>

            {/* The Solution Fold */}

            <div className="lgbox  problem">

                <Container fluid className="tpfold pdr0 mbpdr15">
                    <Row>
                        <Col lg="10" md="10" sm="12" xs="12" className="padmmdt mbpt0 casebox offset-lg-1 ">
                            <p className="text-left p1 mrg30 " > <span class="spcase">THE</span> <strong>SOLUTION</strong>  </p>
                        </Col>
                        <Col lg="10" md="10" sm="12" xs="12" className="offset-lg-1 ">
                            <table className='solution-table'>
                                <thead>
                                    <tr>
                                        <th>Problem</th>

                                        <th>What We Do (Solution)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className='golden-cell'>Too broad and irrelevant audiences</td>

                                        <td>Target only high intent parents using OSIDE-style precision audiences</td>
                                    </tr>
                                    <tr>
                                        <td className='golden-cell'>Trust barriers with parents</td>

                                        <td>Build strong brand trust with KSA heritage, certifications, and real mom reviews</td>
                                    </tr>
                                    <tr>
                                        <td className='golden-cell'>Lacks a clear identity in the UAE market</td>

                                        <td>Create clear brand identity for UAE using storytelling, ambassadors, and packaging</td>
                                    </tr>
                                    <tr>
                                        <td className='golden-cell'>Low-quality traffic or irrelevant platforms</td>

                                        <td>Shift traffic to relevant platforms, parenting communities, and curated whitelists</td>
                                    </tr>
                                    <tr>
                                        <td className='golden-cell'>Low Conversion due to lack of guidance</td>

                                        <td>Build micro conversion funnels like quizzes, gifting guides, and WhatsApp concierge</td>
                                    </tr>
                                    <tr>
                                        <td className='golden-cell'>Offline store traffic is inconsistent and seasonal</td>

                                        <td>Run hyperlocal + appointment ads to stabilise store footfalls across seasons</td>
                                    </tr>
                                    <tr>
                                        <td className='golden-cell'>The brand is not fully leveraging cultural gifting occasions</td>

                                        <td>Launch cultural gifting collections for Aqiqah, baby showers, first birthdays</td>
                                    </tr>
                                    <tr>
                                        <td className='golden-cell'>Some products may be too traditional or too modern, missing balance</td>

                                        <td>Offer modern yet tradition-aligned designs to win both parents and kids</td>
                                    </tr>
                                    <tr>
                                        <td className='golden-cell'>Legacy brands already have strong market dominance and trust</td>

                                        <td>Use comparison narratives to stand out from long-established legacy brands</td>
                                    </tr>
                                    <tr>
                                        <td className='golden-cell'>Low repeat purchase rate from existing customers</td>

                                        <td>Drive repeat purchases through limited drops, seasonal campaigns, and loyalty hooks</td>
                                    </tr>
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                </Container>
            </div>


            <div className=" seoapproach bgbl padbxsb">

                <Container fluid className="tpfold ">
                    <Row>
                        <Col lg="10" md="10" sm="10" xs="12" className="padmmdt mbpt0 casebox offset-lg-1 ">
                            <p className="text-left p1 mrg30 " > <span class="spcase">Strategic </span><strong> Approach</strong> </p>
                            <div className='solution-item'>
                                <h2 className="tcgold marbxst marbxsb padssmt">Website Strategy for improved sales</h2>
                                <p><strong>Old Website-</strong></p>
                                <ul className='solution-list' style={{ color: '#fff' }}>
                                    <li>Unintuitive UI/UX</li>
                                    <li>Presence of bugs affecting user experience</li>
                                    <li>Limited features compared to modern e-commerce standards</li>
                                    <li>Outdated Shopify setup</li>
                                    <li>Awry and confusing website flow</li>
                                    <li>Missing omnichannel integration</li>
                                    <li>No buying guidance for users</li>
                                    <li>Underutilised social media channels</li>
                                    <li>Lack of customer trust</li>
                                </ul>
                                <br></br>
                                <div className='solution-item-graphs'>
                                    <Row>
                                        <Col lg="6" md="6" sm="12" xs="12">
                                            <p><strong>Old Website-</strong></p>
                                            <img className='solution-img' src={`${process.env.PUBLIC_URL}/img/casestudy/baby-jewels/old-website.png`} />
                                             <br></br>
                                            <br></br>
                                        </Col>
                                        <Col lg="6" md="6" sm="12" xs="12">
                                            <p><strong>New Website-</strong></p>
                                            <img className='solution-img' src={`${process.env.PUBLIC_URL}/img/casestudy/baby-jewels/new-website.png`} />
                                        </Col>
                                    </Row>
                                </div>
                            </div>

                            <div className='solution-item'>
                                <h2 className="tcgold marbxst marbxsb padssmt">CRO Optimized Website</h2>
                              
                                <div className='solution-item-graphs'>
                                    <Row>
                                        <Col lg="8" md="7" sm="12" xs="12">
                                            <ul className='solution-list' style={{ color: '#fff' }}>
                                                <li>Story and emotion-led brand experience</li>
                                                <li>Seamless UI/UX with improved load times and cohesive design colour palettes</li>
                                                <li>Additional features like “You May Also Like”, product bundling, stacked discounts on cart, wishlisting, and additional payment gateways</li>
                                                <li>Clear and organized layout with intuitive navigation</li>
                                                <li>Optimized product pages with delivery timelines, detailed product descriptions, and discount code visibility</li>
                                                <li>Increased trust factor through influencer videos and trust badges</li>
                                                <li>Fully responsive design across devices</li>
                                            </ul>
                                        </Col>
                                        <Col lg="4" md="5" sm="12" xs="12">
                                            <img className='solution-img' src={`${process.env.PUBLIC_URL}/img/casestudy/baby-jewels/cro-optimised-website.png`} />
                                        </Col>
                                    </Row>
                                </div>
                            </div>


                            <div className='solution-item'>
                                <h2 className="tcgold marbxst marbxsb padssmt">Assisted WhatsApp Sales and Marketing</h2>
                                <p>Assisted sales greatly benefit jewelry brands by providing customers with expert guidance. Jewelry is personal, so shoppers appreciate insights on each piece’s story, quality, and value. This personalized approach builds trust and fosters repeat business.</p>
                                <p>We helped the brand close many deals with assisted sales via direct queries and whatsapp marketing.
                                </p>

                                <br></br>

                            </div>


                            <div className='solution-item'>
                                <h2 className="tcgold marbxst marbxsb padssmt">Luxury Trageting</h2>
                                <p>It is very clear to us, we do not cater to the mass. We hyper-target only to our target audience and find a pocket of customers who might be interested in our products. We do this by location targeting, interests and behavior targeting.</p>
                                <p>This was done by mapping the locations where customers live and narrowing them down with our proprietary media tool OSIDE’s targeting.</p>

                                <div className='solution-item-graphs'>

                                    <img className='solution-img' src={`${process.env.PUBLIC_URL}/img/casestudy/baby-jewels/map-loc.png`} />

                                </div>

                            </div>


                            <div className='solution-item'>
                                <h2 className="tcgold marbxst marbxsb padssmt">Audience Segmentation</h2>

                                <ul className='solution-list' style={{ color: '#fff' }}>
                                    <li>Dual targeting: Parents (focus on safety, value) and gift-givers (focus on customization, luxury)</li>
                                    <li>Retargeting strategies for cart abandoners with dynamic ads showcasing bestsellers like butterfly earrings</li>

                                </ul>
                                <br></br>

                            </div>

                            <div className='solution-item'>
                                <h2 className="tcgold marbxst marbxsb padssmt">SEO & Page ranking</h2>
                                <p>Earlier, when you searched Baby Jewels anywhere in UAE other brands and products would show up with our brand nowhere in sight. With rigorous SEO, ranking techniques, keyword/headline/description optimization, our page ranks on the first page with all related keywords.</p>
                                <br></br>
                            </div>

                        </Col>
                    </Row>
                </Container>
            </div>


            <div className=" seoapproach bgbl padbxsb">

                <Container fluid className="tpfold ">
                    <Row>
                        <Col lg="10" md="10" sm="10" xs="12" className="padmmdt mbpt0 casebox offset-lg-1 ">
                            <p className="text-left p1 mrg30 " > <span class="spcase">THE</span><strong> IMPACT</strong> </p>


                            <div className='solution-item'>
                                <h2 className="tcgold marbxst marbxsb padssmt">Objective 1- Improve Online Sales</h2>

                                <ul className='solution-list' style={{ color: '#fff' }}>
                                    <li>4 month comparison</li>
                                </ul>
                                <br></br>
                                <div className='solution-item-graphs'>
                                    <Row>
                                        <Col lg="6" md="6" sm="12" xs="12">
                                            <p><strong>Before A&B</strong></p>
                                            <p>Sales and orders were down by 35% and 25% respectively.</p>
                                            <br></br>
                                            <br></br>
                                            <img className='solution-img' src={`${process.env.PUBLIC_URL}/img/casestudy/baby-jewels/impact-before.png`} />
                                             <br></br>
                                            <br></br>
                                        </Col>
                                        <Col lg="6" md="6" sm="12" xs="12">
                                            <p><strong>After A&B</strong></p>
                                            <p>We scaled by 386% in sales and 384% in orders. Our sessions also increased by 116% and so did conversion rate by 187% </p>
                                            <img className='solution-img' src={`${process.env.PUBLIC_URL}/img/casestudy/baby-jewels/impact-after.png`} />
                                        </Col>
                                    </Row>
                                </div>
                            </div>

                            <div className='solution-item'>
                                <h2 className="tcgold marbxst marbxsb padssmt">Objective 2- Improve Store Footfalls</h2>
                                <br></br>
                                <div className='solution-item-graphs'>
                                    <Row>
                                        <Col lg="6" md="6" sm="12" xs="12">
                                            <p><strong>Our Impact</strong></p>
                                            <ul className='solution-list' style={{ color: '#fff' }}>
                                                <li>4 month comparison (Jan-April 2024 v. May- Aug 2024)
                                                    Combined Store Revenue Trajectory since we started advertising in end of May. The downfall was arrested and a new era of growth begun.
                                                </li>
                                            </ul>
                                        </Col>
                                        <Col lg="6" md="6" sm="12" xs="12">
                                            <img className='solution-img' src={`${process.env.PUBLIC_URL}/img/casestudy/baby-jewels/impact-comp.png`} />
                                        </Col>
                                    </Row>
                                </div>
                                
                            </div>

                        </Col>
                    </Row>
                </Container>
            </div>




            <div className="lgbox build endbox">
                <Container fluid className="pdlr0">
                    <Row className="text-left  mglr0">

                        <Col lg="6" sm="6" xs="12">
                            <Link to={`${process.env.PUBLIC_URL}/case-studies/isaia-retail-store-digital-transformation.html`}>
                                <Row className="marssmt marssmb mglr0">

                                    <Col lg="3" sm="3" xs="3" >
                                        <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/footerlogo/isaia.png`} className="mx-auto img-fluid text-right" />
                                    </Col>
                                    <Col lg="5" sm="6" xs="7">

                                        <h4 className="tcgold">ISAIA </h4>
                                        <p>Store Footfalls increased by 100% in 4 months </p>
                                    </Col>
                                    <Col lg="2" sm="3" xs="2" className="marbxst">
                                        <img src={`${process.env.PUBLIC_URL}/img/righticon.png`} width="40%" className=" text-right" />
                                    </Col>
                                </Row>
                            </Link>
                        </Col>

                        <Col lg="6" sm="6" xs="12" className="bgbl " >
                            <Link to={`${process.env.PUBLIC_URL}/case-studies/ecommerce-conversion-rate-case-study.html`}>
                                <Row className="marssmt marssmb mglr0">
                                    <Col lg="3" sm="3" xs="3" >
                                        <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/footerlogo/saundh.png`} className="mx-auto img-fluid text-right" />
                                    </Col>
                                    <Col lg="5" sm="6" xs="7">

                                        <h4 className="tcgold">Saundh </h4>
                                        <p>5X Improvement in E-Commerce Conversion Rate.</p>
                                    </Col>
                                    <Col lg="2" sm="3" xs="2" className="marbxst">
                                        <img src={`${process.env.PUBLIC_URL}/img/righticon.png`} width="40%" className=" text-right" />
                                    </Col>
                                </Row>
                            </Link>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>

    )
}
export default BabyJewels;


function Process() {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        adaptiveHeight: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                    adaptiveHeight: true,
                }
            },],
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                    adaptiveHeight: false,
                }
            },]
    };
    const next = () => {
        Slider.current.slickNext();
    }
    const previous = () => {
        Slider.current.slickPrev();
    }
    return (
        // <Container fluid className="reasons padslgt padslgb casestudy ">
        <Container fluid className="reasons padslgb casestudy ">
            <Row>
                <Col lg="10" className="offset-lg-1">
                    <Slider {...settings}>
                        <div>
                            <Row>

                                <Col className="offset-lg-1 offset-sm-1" lg={{ span: 5, order: 'first' }} sm={{ span: 6, order: 'first' }} xs={{ span: 12, order: 'last' }} >
                                    <h2 className="padt190"><span>Intent Targeting</span></h2>
                                    <ul className='process-slider-list'>
                                        <li>Based on interests</li>
                                        <li>Based on occasion (for eg engagement rings, promise rings etc.)
                                            Gifting
                                        </li>
                                        <li>Hyper-local targeting based on luxury locations</li>
                                    </ul>
                                </Col>
                                <Col className="offset-lg-1 mgm90" lg={{ span: 4, order: 'first' }} sm={{ span: 4, order: 'last' }} xs={{ span: 12, order: 'first' }}>
                                    <img src={`${process.env.PUBLIC_URL}/img/casestudy/scarlet/process_ladder_1.png`} className="custmt80  padslg125 mimgw img-fluid mx-auto d-block" />
                                </Col>

                            </Row>
                        </div>
                        <div>
                            <Row>

                                <Col className="offset-lg-1 offset-sm-1" lg={{ span: 5, order: 'first' }} sm={{ span: 6, order: 'first' }} xs={{ span: 12, order: 'last' }} >
                                    <h2 className="padt190"><span>Awareness</span></h2>
                                    <ul className='process-slider-list'>
                                        <li>Remarket to the customers, instilling brand recognition</li>
                                        <li>Trigger- piqued by the initial exposure, consumers start looking for more information.
                                        </li>
                                        <li>Content- Infographics, Influencer Collabs with engagements in focus</li>
                                    </ul>
                                </Col>
                                <Col className="offset-lg-1 mgm90" lg={{ span: 4, order: 'first' }} sm={{ span: 4, order: 'last' }} xs={{ span: 12, order: 'first' }}>
                                    <img src={`${process.env.PUBLIC_URL}/img/casestudy/scarlet/process_ladder_2.png`} className="custmt80  padslg125 mimgw img-fluid mx-auto d-block" />
                                </Col>

                            </Row>
                        </div>
                        <div>
                            <Row>

                                <Col className="offset-lg-1 offset-sm-1" lg={{ span: 5, order: 'first' }} sm={{ span: 6, order: 'first' }} xs={{ span: 12, order: 'last' }} >
                                    <h2 className="padt190"><span>Consideration</span></h2>
                                    <ul className='process-slider-list'>
                                        <li>Remarket comprehensive product pages, sales and offerings, informational content, price differentiation</li>
                                        <li>Trigger- Consumers recognize the value and benefits of lab-grown diamonds but want to explore options and compare prices.</li>
                                    </ul>
                                </Col>
                                <Col className="offset-lg-1 mgm90" lg={{ span: 4, order: 'first' }} sm={{ span: 4, order: 'last' }} xs={{ span: 12, order: 'first' }}>
                                    <img src={`${process.env.PUBLIC_URL}/img/casestudy/scarlet/process_ladder_3.png`} className="custmt80  padslg125 mimgw img-fluid mx-auto d-block" />
                                </Col>

                            </Row>
                        </div>
                        <div>
                            <Row>

                                <Col className="offset-lg-1 offset-sm-1" lg={{ span: 5, order: 'first' }} sm={{ span: 6, order: 'first' }} xs={{ span: 12, order: 'last' }} >
                                    <h2 className="padt190"><span>Purchase Decision</span></h2>
                                    <ul className='process-slider-list'>
                                        <li>Track:  They add the item to their cart, apply any discounts or promo codes, and complete the checkout process.</li>
                                        <li>Redirect customers to the store</li>
                                    </ul>
                                </Col>
                                <Col className="offset-lg-1 mgm90" lg={{ span: 4, order: 'first' }} sm={{ span: 4, order: 'last' }} xs={{ span: 12, order: 'first' }}>
                                    <img src={`${process.env.PUBLIC_URL}/img/casestudy/scarlet/process_ladder_4.png`} className="custmt80  padslg125 mimgw img-fluid mx-auto d-block" />
                                </Col>

                            </Row>
                        </div>
                    </Slider>
                </Col>
            </Row>
        </Container>
    );
}
